<template>
  <div id="cashDrawerManagement">
    <PageTitle :title="$t('pos.cash_drawer.management_title')" :subtitle="$t('pos.cash_drawer.management_description')" />

    <div class="container">
      <Panel :showTitle="false">
        <Datatable entity="cash_drawer_transaction" :parameters="parameters" :maps="maps"></Datatable>
      </Panel>
    </div>
  </div>
</template>

<script>
  import PageTitle from "@/components/PageTitle.vue";
  import Datatable from "@/components/Datatable.vue";

  export default {

    components: { PageTitle, Datatable },

    data() {
      return {
        parameters: {
          company: this.$route.query.company
        },
        maps: [
          null,
          type => this.$t("pos.cash_drawer." + type),
          null,
          null,
          null,
          null
        ]
      };
    }

  };
</script>

<style lang="scss" scoped>
  #cashDrawerManagement {
    display: flex;
    flex-direction: column;

    .panel {
      flex-grow: 1;
      .content, .content-inner {
        height: 100%;
      }
    }
  }
</style>

<style lang="scss">
#cashDrawerManagement .panel {
  .content, .content-inner, .datatable {
    height: 100%;
  }
}
</style>